import {useAuth} from '@apps-common/auth-react';
import {MapAuthProvider} from '@apps-common/ui-maps/context';
import {Box, CssBaseline} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';
import {ErrorBoundary} from '@sentry/react';
import React from 'react';
import {Helmet} from 'react-helmet';
import {theme} from '../styles/index.jsx';
import AppContent from './App.jsx';
import TopNavBar from '@app/components/TopNavBar';
import ErrorPage from '@app/components/common/ErrorPage';
import {API_TARGET, MAPBOX_ACCESS_TOKEN} from '@app/config';
import appGlobalStyles from '@app/styles/AppGlobalStyles.jsx';

const AppLayout = () => {
  const {user} = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <MapAuthProvider
        mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
        authToken={user.accessToken}
        authTarget={API_TARGET}
      >
        <Helmet>
          <title>Features Manager</title>
          <meta itemProp="name" content="Features Manager" />
          <meta property="og:title" content="Features Manager" />
          <meta
            property="og:description"
            content="Manage your areas of interest"
          />
          <meta
            property="og:url"
            content="https://www.planet.com/featuresManager/"
          />
        </Helmet>

        <CssBaseline />

        {appGlobalStyles}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
          }}
        >
          <ErrorBoundary
            fallback={errorProps => (
              <ErrorPage sentryEventId={errorProps.eventId} />
            )}
            showDialog
            dialogOptions={{
              user: {
                name: user.claims.name,
                email: user.claims.email,
              },
            }}
          >
            <TopNavBar />

            <AppContent />
          </ErrorBoundary>
        </Box>
      </MapAuthProvider>
    </ThemeProvider>
  );
};

export default AppLayout;
